import { ContainerGetAllQuery } from '../../types';
import { Chip, FlagIcon, Typography } from '../../design-system';
import { CardBase, CardInfo, ContainerPhoto, AddressTypography, ChipButton } from '../dashboard';
import { formatContainerType, showToRoles } from '../../utils';
import {
  ContainerConditionToChipLabels,
  ContainerStatusToChipColors,
  ContainerStatusToChipLabels,
} from '../../const';
import { i18n } from '../../i18n';
import { useStore } from '../../context';

interface CardProps {
  handleRowClick: any;
  handleClickImage: any;
  handleDotsOptionSelect: any;
}

export const Card = ({
  handleRowClick = () => {},
  handleClickImage,
  handleDotsOptionSelect,
  ...container
}: CardProps & ContainerGetAllQuery['data'][number]) => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();

  return (
    <CardBase onClick={handleRowClick}>
      <ContainerPhoto
        src={container.images[0]?.url}
        onClick={(e) => {
          e.stopPropagation();
          if (container.images[0]?.url) handleClickImage(container.images);
        }}
      />
      <CardInfo
        column={container._count.repair ? '1fr max-content max-content' : '1fr max-content'}
      >
        <Typography variant={'textS'}>{container.number}</Typography>
        <Chip
          size={'small'}
          label={ContainerStatusToChipLabels[container.status]}
          color={'borderless'}
        />
      </CardInfo>
      <CardInfo column={'max-content max-content max-content'}>
        <Chip size={'small'} label={formatContainerType(container.type)} color={'borderless'} />
        {container.condition && (
          <Chip
            size={'small'}
            label={ContainerConditionToChipLabels[container.condition]}
            color={'borderless'}
          />
        )}
        {!!container._count.repair && (
          <Chip size={'small'} label={i18n.t('label.chip.repairing')} color={'borderless'} />
        )}
      </CardInfo>
      <CardInfo>
        <AddressTypography variant={'textS'}>
          <FlagIcon country={container.clientYard.yard.address.country} />
          {container.clientYard.yard.address.city}
        </AddressTypography>
        {!!container.sale && (
          <Chip
            size={'small'}
            label={ContainerStatusToChipLabels[container.sale.status]}
            color={ContainerStatusToChipColors[container.sale.status]}
          />
        )}
        {!container.sale &&
          container.canTrade &&
          container.status === 'GATED_IN' &&
          showToRoles(['SUPER_ADMIN', 'CLIENT_MANAGER', 'CLIENT_DISPATCHER'], user) && (
            <ChipButton
              size={'medium'}
              label={i18n.t('button.sell')}
              color={'blue'}
              onClick={(e) => {
                e.stopPropagation();
                handleDotsOptionSelect(container, container.number, 'sell', container.id);
              }}
            />
          )}
      </CardInfo>
    </CardBase>
  );
};
